import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=1052ddf6&scoped=true"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=1052ddf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1052ddf6",
  null
  
)

export default component.exports